/** Вид пресета списка и право текущего пользователя его править — то, от чего зависят действия над ним. */
type PresetAccessSubject = {
  isSystem: boolean;
  isShared: boolean;
  isEditable: boolean;
};

/**
 * Действия над пресетом, доступные текущему пользователю: пресетом таблицы и пользовательским
 * дашбордом пользователь распоряжается по одним правилам.
 */
export type PresetAccess = {
  /** Личный пресет можно сделать системным — при разрешении на системные пресеты */
  canMakeSystem: boolean;
  /** Поделиться можно личным и совместным, которым пользователь владеет; системный и так виден всем */
  canShare: boolean;
  /** Закрепить в меню и удалить: свой пресет, а совместный — и получателю, у себя */
  canPinAndRemove: boolean;
  /** Удаление убирает совместный пресет только из списка получателя */
  isRemovedForSelfOnly: boolean;
};

/** Действия над пресетом, доступные текущему пользователю. */
export const getPresetAccess = (preset: PresetAccessSubject, canManageSystemPresets: boolean): PresetAccess => {
  const isPersonal = !preset.isSystem && !preset.isShared;
  return {
    canMakeSystem: isPersonal && canManageSystemPresets,
    canShare: isPersonal || (preset.isShared && preset.isEditable),
    canPinAndRemove: preset.isEditable || preset.isShared,
    isRemovedForSelfOnly: preset.isShared && !preset.isEditable,
  };
};
